/**
 * State used in rendering TableHeaderCell
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
